module.exports = __webpack_public_path__ + "img/Checked.ade9afbf.svg";